import './Filter.css'

function Filter(props) {

    const handleEuropean = () => {
        props.setShowEuropean(!props.showEuropean)
    }

    const handleCategory = category => {
        props.setFilterCategory(prevState => {
            return (
                {
                    ...prevState,
                    [category]: !prevState[category]
                }
            )
        })
    }

    return (
        <>
            <h1>Filter</h1>
            <h2>Visa kategori:</h2>
            <div className="filterChoise">
                <label className="classic">
                    <div>Grönsaker</div>
                    <input type="checkbox"
                    checked={props.filterCategory.vegetable}
                    onChange={() => handleCategory("vegetable")}
                    />
                </label>
                <label className="classic">
                <div>Rotfrukter</div>
                    <input type="checkbox"
                    checked={props.filterCategory.root}
                    onChange={() => handleCategory("root")}
                    />
                </label>
                <label className="classic">
                    <div>Örter</div>
                    <input type="checkbox"
                    checked={props.filterCategory.herb}
                    onChange={() => handleCategory("herb")}
                    />
                </label>
                <label className="classic">
                    <div>Frukt</div>
                    <input type="checkbox"
                    checked={props.filterCategory.fruit}
                    onChange={() => handleCategory("fruit")}
                    />
                </label>
                <label className="classic">
                    <div>Bär</div>
                    <input type="checkbox"
                    checked={props.filterCategory.berry}
                    onChange={() => handleCategory("berry")}
                    />
                </label>
                <label className="classic">
                    <div>Svamp</div>
                    <input type="checkbox"
                    checked={props.filterCategory.mushroom}
                    onChange={() => handleCategory("mushroom")}
                    />
                </label>
            </div>
            <h4>Visa grödor som inte odlas i Sverige: </h4>
            <label className="switch">
                <input type="checkbox"
                 checked={props.showEuropean}
                 onChange={handleEuropean}
                 />
                <span className="slider round"></span>
            </label>
            <br />
            <br />
            <br />
            <br />
        </>
    )
}

export default Filter